import { useCallback, useEffect, useRef, useState } from 'react';
import { ClickAwayListener, Dialog, DialogContent, DialogTitle, IconButton, Paper, Popper } from '@mui/material';
import CampaignTwoToneIcon from '@mui/icons-material/CampaignTwoTone';
import CloseIcon from '@mui/icons-material/Close';
import Markdown from 'react-markdown';
import NavigationBarItem from '../NavigationBarItem';
import { NavItemProps } from '../types';

import styles from './ReleaseNotes.module.css';

export default function ReleaseNotes({ isDesktopOpen, isMobile, ...props }: NavItemProps) {
  const [open, setOpen] = useState(false);
  const [markdown, setMarkdown] = useState('');
  const anchorRef = useRef<HTMLDivElement>(null);
  const noop = useCallback(() => {
    /* prevent mobile drawer auto-close */
  }, []);

  useEffect(() => {
    void fetch(`/Release-Notes.md?v=${NPM_PACKAGE_VERSION}`)
      .then((res) => res.text())
      .then((text) => {
        setMarkdown(text);
      });
  }, []);

  const handleToggle = useCallback(() => {
    setOpen((prev) => !prev);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <>
      <div ref={anchorRef}>
        <NavigationBarItem
          key='navbar-item-release-notes'
          item={{
            displayText: 'Release Notes',
            icon: <CampaignTwoToneIcon />,
            title: 'Release Notes',
            onClick: handleToggle
          }}
          open={isDesktopOpen}
          isMobile={isMobile}
          mobileMenuOpen={props.mobileMenuOpen}
          setMobileMenuOpen={isMobile ? noop : props.setMobileMenuOpen}
        />
      </div>
      {isMobile ? (
        <Dialog
          open={open}
          onClose={handleClose}
          fullScreen
          maxWidth='sm'
          slotProps={{ paper: { className: styles.paper } }}>
          <DialogTitle sx={{ m: 0, p: 0.5, marginTop: 0 }}>
            <span style={{ fontWeight: 800, fontSize: '24px' }}>Release Notes</span>
            <IconButton
              aria-label='close'
              onClick={handleClose}
              sx={{ position: 'absolute', right: 8, top: 8 }}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Markdown>{markdown}</Markdown>
          </DialogContent>
        </Dialog>
      ) : (
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          placement='right-start'
          className={styles.popper}>
          <ClickAwayListener onClickAway={handleClose}>
            <Paper
              elevation={8}
              className={styles.paper}>
              <div className={styles.header}>
                <span className={styles.title}>Release Notes</span>
                <IconButton
                  aria-label='close'
                  onClick={handleClose}
                  size='small'>
                  <CloseIcon fontSize='small' />
                </IconButton>
              </div>
              <Markdown>{markdown}</Markdown>
            </Paper>
          </ClickAwayListener>
        </Popper>
      )}
    </>
  );
}
